export const CART_COOKIE = 'cartId';
export const COUNTRY_COOKIE = 'countryCode';
export const CURRENCY_COOKIE = 'currencyCode';
export const META_SHOP_COOKIE = 'metaShopParams';
export const SEGMENT_ANONYMOUS_ID_COOKIE = 'ajs_anonymous_id';
export const STATSIG_COOKIE = 'statsigStableId';
// Cookie set by client when real analytics has loaded (!window.analytics._isOneTrustStub)
export const SEGMENT_ANALYTICS_LOADED_COOKIE = 'segment_analytics_loaded';
